import {CookiesStorageService} from '@core/services/cookies-storage.service';
import {LocalStorageService} from '@core/services/local-storage.service';
import {Injectable} from '@angular/core';

export enum StorageType {
    Local,
    Cookie
}

@Injectable({
    providedIn: 'root'
})
export class StorageService {

    constructor(private _local: LocalStorageService,
                private _cookie: CookiesStorageService) {
    }

    getStorage(type?: StorageType) {
        switch (type) {
            case StorageType.Cookie:
                return this._cookie;
            case StorageType.Local:
                return this._local;
            default:
                return this.getStorage(StorageType.Local);
        }
    }

    get<T = any>(token: string, type?: StorageType) {
        const storage = this.getStorage(type);
        return storage.get(token);
    }

    set<T = any>(token: string, data: T, type?: StorageType) {
        const storage = this.getStorage(type);
        return storage.set(token, data);
    }

    remove(token: string, type?: StorageType) {
        const storage = this.getStorage(type);
        return storage.remove(token);
    }

    clear(type?: StorageType) {
        const storage = this.getStorage(type);
        return storage.clear();
    }

}
